export default "__VITE_ASSET__BW9P3PT4__"